import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { COMMUNITY_URL } from '../app.constants';

@Injectable()
export class CommunityRedirectGuard  {

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        window.location.href = COMMUNITY_URL;
        return false;
    }
}
